import React from "react";
import { StarIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { testimonials } from "../../data/landingContent";
export function TestimonialsSection() {
  return <section className="bg-cream px-4 py-14 sm:py-20" data-id="element-292" data-mp="1rtuyxbmj99ju">
      <SectionHeading eyebrow="What physicians are saying" title={<>
            Clinicians who brought <em className="text-rose" data-id="element-294" data-mp="1ivrdsgfgmesk">structure</em> to their consultations
          </>} data-id="element-293" data-mp="1mxcvqg6upj9m" />
      <div className="mx-auto mt-10 grid max-w-5xl grid-cols-1 gap-5 md:grid-cols-2" data-id="element-295" data-mp="1dubp8ee2pq5f">
        {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-[0_10px_30px_-18px_rgba(27,36,71,0.35)]" data-id="element-296" data-mp="18ywfnyn3mget">
            <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-297" data-mp="33akywd0d5550">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-298" data-mp="2yd1jh9rximbh" data-mpi={i} />)}
            </div>
            <blockquote className="mt-4 text-[17px] leading-relaxed text-ink" data-id="element-299" data-mp="1tbzvt79udf44">“{t.quote}”</blockquote>
            <figcaption className="mt-auto flex items-center gap-4 pt-6" data-id="element-300" data-mp="1y6dkyrxwuq0c">
              <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-blush" loading="lazy" data-id="element-301" data-mp="1jdacda2armlr" />
              <div data-id="element-302" data-mp="2c27sp7my79bv">
                <p className="font-bold text-ink" data-id="element-303" data-mp="2gz7xlf82a61e">{t.name}</p>
                <p className="text-sm text-muted" data-id="element-304" data-mp="2gyg3k8u44gd8">{t.role}</p>
              </div>
            </figcaption>
          </figure>)}
      </div>
      <CtaButton className="mt-10" label="I want the same clarity in my practice" data-id="element-305" data-mp="2794zj0m321w7" />
    </section>;
}